import { MOBILE_MODE } from '@constants/size';
import styled from '@emotion/styled';
import { white } from '@styles/Colors';
import { Shadow } from '@styles/Shadow';

type Props = {
  text?: React.ReactNode;
  button1?: React.ReactNode;
  button2?: React.ReactNode;
  button3?: React.ReactNode;
};

const Layout = styled.div`
  width: 100%;
  padding: 24px 0;
  position: fixed;
  bottom: 0;
  left: calc(-50vw + 50%);
  box-shadow: ${Shadow.MEDIUM};
  background: ${white};

  text-align: center;

  display: grid;
  row-gap: 16px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 16px;

  @media ${MOBILE_MODE} {
    width: 320px;

    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 0 auto;
  }
`;

export default function FloatingButtonSection({ text, button1, button2, button3 }: Props) {
  return (
    <Layout>
      {text}
      <ButtonWrapper>
        {button1}
        {button2}
        {button3}
      </ButtonWrapper>
    </Layout>
  );
}
